var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserManager as OIDCUserManager, WebStorageStateStore } from 'oidc-client';
import { OIDCDefaultSettings } from './oidc-default-settings';
import { SignInMethodPopUp } from "./sign-in-methods";
export class UserManager {
    constructor(client_id, scope, signInMethod, authority = OIDCDefaultSettings.authority, extraQueryParams, store = window.sessionStorage) {
        const oidcClientSettings = Object.assign(Object.assign(Object.assign(Object.assign({}, OIDCDefaultSettings), { authority: authority, client_id, scope: OIDCDefaultSettings.scope + ' ' + scope }), signInMethod), { extraQueryParams: extraQueryParams, userStore: new WebStorageStateStore({ store: store }) });
        this._settings = oidcClientSettings;
        this._signInMethod = signInMethod;
        this._oidcManager = new OIDCUserManager(oidcClientSettings);
    }
    get user() {
        if (this._user) {
            return Promise.resolve(this._user);
        }
        return this._oidcManager.getUser().then(user => {
            this._user = user;
            return user;
        });
    }
    signIn() {
        if (this._signInMethod instanceof SignInMethodPopUp) {
            return this._oidcManager.signinPopup().then(user => {
                this._user = user;
                return user;
            });
        }
        return this._oidcManager.signinRedirect();
    }
    signOut(args) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._signInMethod instanceof SignInMethodPopUp) {
                yield this._oidcManager.signoutPopup().then(() => {
                    this._user = null;
                });
            }
            else {
                yield this._oidcManager.signoutRedirect(Object.assign(Object.assign({}, args), { useReplaceToNavigate: true }));
            }
            return void 0;
        });
    }
    renew() {
        return this._oidcManager.signinSilent().then(user => {
            this._user = user;
            return user;
        });
    }
    isSignedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.user;
            return user ? !user.expired : false;
        });
    }
}
//# sourceMappingURL=user-manager.js.map